export default function useGAnalytics() {
  const nuxtApp = useNuxtApp();
  const gaPropertyId = useRuntimeConfig().public.GA_PROPERTY_ID;

  const enabled = computed(() =>
    nuxtApp.$appConfig?.integrations.includes("google_analytics_integration"),
  );

  const getGAnalyticsScript = () => {
    if (enabled.value && gaPropertyId) {
      return [
        {
          async: true,
          src: `https://www.googletagmanager.com/gtag/js?id=${gaPropertyId}`,
        },
        {
          innerHTML: `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${gaPropertyId}');
            `,
        },
      ];
    }
    return [];
  };

  return { getGAnalyticsScript };
}
